import { Button } from "antd";

export type AuthenticationErrorPageProps = Readonly<{
  retry(): void;
}>;

export function AuthenticationErrorPage({ retry }: AuthenticationErrorPageProps) {
  return (
    <main className="auth-error-page" aria-live="polite">
      <h1 className="auth-error-heading">Không thể kết nối dịch vụ xác thực</h1>
      <p className="auth-error-description">
        Hệ thống chưa thể xác thực danh tính của bạn vào lúc này. Vui lòng thử lại
        sau ít phút.
      </p>
      <Button type="primary" onClick={retry}>
        Thử lại
      </Button>
    </main>
  );
}